import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from 'components/ui/Button';
import Icon from 'components/AppIcon';
import SEO from '../components/SEO';

const NotFound = () => {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(5);

  const handleGoHome = () => {
    navigate('/');
  };

  useEffect(() => {
    // Countdown timer
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          navigate('/');
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    // Cleanup on unmount
    return () => clearInterval(timer);
  }, [navigate]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background p-4">
      <SEO 
        title="Page Not Found"
        description="The page you're looking for doesn't exist. Return to EmailValidator homepage to continue using our email validation services."
        keywords="404, page not found, error page, broken link, missing page"
        canonical="https://mailvalidator.octalchip.com/404"
      />
      <div className="text-center max-w-md">
        <div className="flex justify-center mb-6">
          <div className="relative">
            <h1 className="text-9xl font-bold text-primary opacity-20">404</h1>
          </div>
        </div>

        <h2 className="text-2xl font-medium text-onBackground mb-2">Page Not Found</h2>
        <p className="text-onBackground/70 mb-4">
          The page you're looking for doesn't exist. Let's get you back!
        </p>
        
        <div className="mb-8 p-4 bg-primary/10 rounded-lg border border-primary/20">
          <p className="text-onBackground font-medium mb-2">
            Redirecting you to the homepage...
          </p>
          <p className="text-onBackground/70 text-sm">
            You will be redirected in {countdown} second{countdown !== 1 ? 's' : ''}
          </p>
        </div>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button
            variant="primary"
            icon={<Icon name="ArrowLeft" />}
            iconPosition="left"
            onClick={() => window.history.back()}
          >
            Go Back
          </Button>

          <Button
            variant="outline"
            icon={<Icon name="Home" />}
            iconPosition="left"
            onClick={handleGoHome}
          >
            Back to Home
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
